export default __webpack_public_path__ + "static/media/icn_lock.edd7c996.svg";